import { fireStructuredSnowplowEvent } from 'wanderu-service-analytics';

const category = 'search_widget';

const events = {
    clickExplore(userText) {
        fireStructuredSnowplowEvent({
            action: 'click',
            category: 'search_widget',
            label: 'explore_destinations',
            property: {
                userText,
            },
        });
    },

    clickSearchType({
        cleanedSearchType,
        departDate,
        destinationInput,
        originInput,
        returnDate,
    }) {
        fireStructuredSnowplowEvent({
            action: 'click',
            category,
            label: 'roundtrip_oneway_selector',
            property: {
                destination: destinationInput,
                origin: originInput,
                outbound_date: departDate,
                return_date: returnDate,
                selector_changed_to: cleanedSearchType,
            },
        });
    },

    clickSwitch({
        departDate,
        destinationInput,
        originInput,
        returnDate,
    }) {
        fireStructuredSnowplowEvent({
            action: 'click',
            category,
            label: 'direction_switcher',
            property: {
                outbound_date: departDate,
                return_date: returnDate,
                was_destination: destinationInput,
                was_origin: originInput,
            },
        });
    },

    clickTripzAdTriggered(enabled, userCtzPref, queryMap) {
        fireStructuredSnowplowEvent({
            action: 'submitted',
            category,
            label: 'clicktripz ad',
            property: {
                enabled,
                queryMap,
                userCookiePref: userCtzPref,
            },
        });
    },

    clickTripzPreference(enabled) {
        fireStructuredSnowplowEvent({
            action: 'clicked',
            category,
            label: 'clicktripz ad',
            property: {
                enabled,
            },
        });
    },

    focusDateSelector({
        departDate,
        destinationInput,
        isRoundTrip,
        originInput,
        returnDate,
    }) {
        fireStructuredSnowplowEvent({
            action: 'focus',
            category,
            label: 'date_selector',
            property: {
                destination: destinationInput,
                is_one_way: !isRoundTrip,
                origin: originInput,
                outbound_date: departDate,
                return_date: returnDate,
            },
        });
    },

    focusInput(label, text) {
        fireStructuredSnowplowEvent({
            action: 'focus',
            category,
            label,
            property: {
                current_text: text,
            },
        });
    },

    inputSelected(label, inputData) {
        fireStructuredSnowplowEvent({
            action: 'inputted',
            category,
            label,
            property: typeof inputData === 'string'
                ? inputData
                : JSON.stringify(inputData),
        });
    },

    loaded(property) {
        fireStructuredSnowplowEvent({
            action: 'loaded',
            category,
            property,
        });
    },

    searchSubmitted(inputs, errors) {
        const {
            clickTripz,
            departDate,
            destinationInput,
            destinationPlaceId,
            originInput,
            originPlaceId,
            returnDate,
        } = inputs;
        const isInvalid = Object.values(errors).some(Boolean);

        fireStructuredSnowplowEvent({
            action: 'submitted',
            category,
            label: isInvalid
                ? 'invalid'
                : 'valid',
            property: JSON.stringify({
                departDate: departDate,
                destination: {
                    address: destinationInput,
                    placeId: destinationPlaceId,
                },
                errors,
                find_cheap_hotels: clickTripz,
                origin: {
                    address: originInput,
                    placeId: originPlaceId,
                },
                returnDate: returnDate || '',
            }),
        });
    },
};

export default events;
